import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@/components-latest/primitives/Button';
import Text from '@/components-latest/primitives/Text';
import CommonModal from '@/components-latest/shared/Modals/CommonModal';
import Styles from './CreateOfferModal.module.scss';
import { CartDiscountOffer, ClickRight, ItemDiscountOffer, BuyXGetYOffer } from '@/components-latest/primitives/Icons';
import { useHistory } from 'react-router-dom';

interface CreateOfferModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (offerType: 'item_discount' | 'cart_discount' | 'buyX_getY') => void;
  toggleCreationFormVisibility: () => void;
}

const CreateOfferModal: React.FC<CreateOfferModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  toggleCreationFormVisibility,
}) => {
  const { t } = useTranslation();
  const history = useHistory()
  // Handle modal close
  const onCloseModal = () => {
    onClose();
  };

  const handleOfferTypeSelection = (offerType: 'item_discount' | 'cart_discount' | 'buyX_getY') => {
    onSubmit(offerType);
    onClose();
  };

  return (
    <CommonModal
      open={isOpen}
      title={t('offers.select-offer-type.title')}
      onOpenChange={onCloseModal}
      className={Styles.modal}
      scrollableBody
      scrollAreaClass={Styles.scrollable}
      body={
        <>
          {/* Item Discount Option */}
          <div
            className={Styles.offerOption}
            onClick={() => handleOfferTypeSelection('item_discount')}
          >
            <div className={Styles.offerContent}>
              <div className={Styles.iconContainer}>
                <ItemDiscountOffer />
              </div>
              <div className={Styles.textContainer}>
                <Text variant="heading-04" className={Styles.offerTitle}>
                  {t('offers.select-offer-type.item-discount.title')}
                </Text>
                <Text variant="subtitle" className={Styles.offerDescription}>
                  {t('offers.select-offer-type.item-discount.description')}
                </Text>
              </div>
              <div className={Styles.arrowContainer}>
                <ClickRight />
              </div>
            </div>
          </div>

          {/* Cart Discount Option */}
          <div
            className={Styles.offerOption}
            onClick={() => handleOfferTypeSelection('cart_discount')}
          >
            <div className={Styles.offerContent}>
              <div className={Styles.iconContainer}>
                <CartDiscountOffer />
              </div>
              <div className={Styles.textContainer}>
                <Text variant="heading-04" className={Styles.offerTitle}>
                  {t('offers.select-offer-type.cart-discount.title')}
                </Text>
                <Text variant="subtitle" className={Styles.offerDescription}>
                  {t('offers.select-offer-type.cart-discount.description')}
                </Text>
              </div>
              <div className={Styles.arrowContainer}>
                <ClickRight />
              </div>
            </div>
          </div>
          {/* Buy X Get Y Offer Option */}
          <div
            className={Styles.offerOption}
            onClick={() => handleOfferTypeSelection('buyX_getY')}>
            <div className={Styles.offerContent}>
              <div className={Styles.iconContainer}>
                <BuyXGetYOffer /> 
              </div>
              <div className={Styles.textContainer}>
                <Text variant="heading-04" className={Styles.offerTitle}>
                  {t('offers.select-offer-type.buy-x-get-y.title')}
                </Text>
                <Text variant="subtitle" className={Styles.offerDescription}>
                  {t('offers.select-offer-type.buy-x-get-y.description')}
                </Text>
              </div>
              <div className={Styles.arrowContainer}>
                <ClickRight />
              </div>
            </div>
          </div>
        </>
      }
      footer={
        <Button
          className={Styles.cancelButton}
          shape="rounded"
          size="medium"
          onClick={onClose}
          variant="secondary"
        >
          {t('cancel')}
        </Button>
      }
    />
  );
};

export default CreateOfferModal;